import React from "react";

/** Stała wskazówka przy formularzu; wyniki operacji obsługują systemowe toasty. */
export default function PremiumNotice({ children, warning = false }) {
  return (
    <div
      className={`premium-notice${warning ? " premium-notice-warning" : ""}`}
    >
      <i
        className={`bi ${warning ? "bi-exclamation-circle" : "bi-info-circle"}`}
        aria-hidden="true"
      />
      <div>{children}</div>
    </div>
  );
}
